export default "__VITE_ASSET__ClQwymDb__"